import React from "react";
import CotizacionListPage from "../component/Cotizacion/CotizacionListPage";

const Cotizacion = () => <CotizacionListPage />;

export default Cotizacion;
